import React, { useEffect, useState } from "react";
import { login } from "../ds/auth";
import { useDispatch } from "react-redux";
import { setUser } from "../feature/auth";
import { gatAllAggregator } from "../ds/aggregators";
import { gatAllCollector } from "../ds/collectors";
import {
  getLga,
  getLocationCollectionReport,
  getParticipantReport,
  getPerformanceReport,
  getPlasticCollectionReport,
  getPlasticProcessedReport,
  getProgram,
  getSourceOfPlastic,
  getState,
  getLgaByState,
  getStateCollectionReport,
  getTopAggregators,
  getTopCollectors,
  getTopLocation,
  getTopState,
  getTypeOfPlastic,
  getCollectionTargetReport,
} from "../ds/resource";
const useResource = (program) => {
  const [loading, setLoading] = useState();
  const [paReport, setPaReport] = useState({});
  const [peReport, setPeReport] = useState({});
  const [topFiveCollector, setTopFiveCollectors] = useState([]);
  const [topFiveAggregator, setTopFiveAggregators] = useState([]);
  const [topFiveAggYear, setTopFiveAggYear] = useState(1);
  const [topFiveColYear, setTopFiveColYear] = useState(1);
  const [collectionReport, setCollectionReport] = useState([]);
  const [collectionTargetReport, setCollectionTargetReport] = useState([]);
  const [processedReport, setProcessedReport] = useState([]);
  const [collectionTargetYear, setCollectionTargetYear] = useState("");
  const [processedYear, setProcessedYear] = useState(1);
  const [collectionYear, setCollectionYear] = useState(1);
  const [stateYear, setStateYear] = useState(1);
  const [locColYear, setLocColYear] = useState(1);
  const [stateCollectionReport, setStateCollectionReport] = useState();
  const [locationCollectionReport, setLocationCollectionReport] = useState();
  const [topFiveStates, setTopFiveStates] = useState([]);
  const [topFiveLocation, setTopFiveLocation] = useState([]);
  const [topStateYear, setTopStateYear] = useState(1);
  const [topLocationYear, setTopLocationYear] = useState(1);
  const [typeOfPlastic, setTypeOfPlastic] = useState([]);
  const [typeOfPlasticId, setTypeOfPlasticId] = useState(null);
  const [sourceOfPlastic, setSourceOfPlastic] = useState([]);
  const [sourceOfPlasticId, setSourceOfPlasticId] = useState(null);
  const [colTypeOfPlasticId, setColTypeOfPlasticId] = useState(null);
  const [colTargetAggregatorId, setColTargetAggregatorId] = useState(null);
  const [colSourceOfPlasticId, setColSourceOfPlasticId] = useState(null);
  const [offtakeTypeOfPlasticId, setOfftakeTypeOfPlasticId] = useState(null);
  const [offtakeSourceOfPlasticId, setOfftakeSourceOfPlasticId] = useState(null);
  const [collectionReportTimeline, setCollectionReportTimeline] =
    useState("Monthly");
  const [processedReportTimeline, setProcessedReportTimeline] =
    useState("Monthly");
  const [aggregatorId, setAggregatorId] = useState();
  const [peStartDate, setPeStartDate] = useState("");
  const [peEndDate, setPeEndDate] = useState("");

  useEffect(() => {
    if (program) {
      const getAllParticipantReports = async () => {
        try {
          const res = await getAllParticipantReport(program);
          setPaReport(JSON.parse(res).data);
        } catch (error) {}
      };
      getAllParticipantReports();
    }
  }, [program]);
  useEffect(() => {
    if (program) {
      const getAllPerformanceReports = async () => {
        try {
          const res = await getAllPerformanceReport({
            program,
            sourceOfPlasticId: sourceOfPlasticId?.value
              ? sourceOfPlasticId.value
              : "",
            typeOfPlasticId:
              typeOfPlasticId?.value !== 0 && typeOfPlasticId?.value != null
                ? typeOfPlasticId.value
                : "",
            aggregatorId:
              aggregatorId !== 0 && aggregatorId != null ? aggregatorId : "",
            startDate: peStartDate || "",
            endDate: peEndDate || "",
          });
          setPeReport(JSON.parse(res).data);
        } catch (error) {}
      };
      getAllPerformanceReports();
    }
  }, [
    program,
    typeOfPlasticId,
    sourceOfPlasticId,
    aggregatorId,
    peStartDate,
    peEndDate,
  ]);

  useEffect(() => {
    if (topFiveColYear || program) {
      const getTopCollector = async () => {
        try {
          const res = await getTopFiveCollectors(topFiveColYear, program);
          setTopFiveCollectors(JSON.parse(res).data);
        } catch (error) {}
      };
      getTopCollector();
    }
  }, [topFiveColYear, program]);
  useEffect(() => {
    if (topFiveAggYear || program) {
      const getTopAggregator = async () => {
        try {
          const res = await getTopFiveAggregators(topFiveAggYear, program);
          setTopFiveAggregators(JSON.parse(res).data);
        } catch (error) {}
      };
      getTopAggregator();
    }
  }, [topFiveAggYear, program]);
  useEffect(() => {
    if (collectionYear || program) {
      const getReport = async () => {
        try {
          const res = await getPlasticCollectionReport({
            collectionYear: collectionYear,
            calendarType: collectionReportTimeline,
            program: program,
            sourceOfPlasticId: colSourceOfPlasticId?.value,
            typeOfPlasticId: colTypeOfPlasticId?.value,
          });
          setCollectionReport(JSON.parse(res).data);
        } catch (error) {}
      };
      getReport();
    }
  }, [
    collectionYear,
    collectionReportTimeline,
    program,
    colSourceOfPlasticId,
    colTypeOfPlasticId,
  ]);
  useEffect(() => {
    if (processedYear || program) {
      const getReport = async () => {
        try {
          const resPlastic = await getPlasticProcessedReport({
            processedYear: processedYear,
            calendarType: processedReportTimeline,
            program: program,
            sourceOfPlasticId: offtakeSourceOfPlasticId?.value,
            typeOfPlasticId: offtakeTypeOfPlasticId?.value,
          });
          setProcessedReport(JSON.parse(resPlastic).data);
        } catch (error) {}
      };
      getReport();
    }
  }, [
    processedYear,
    processedReportTimeline,
    program,
    offtakeSourceOfPlasticId,
    offtakeTypeOfPlasticId,
  ]);
  useEffect(() => {
    if (stateYear || program) {
      const getReport = async () => {
        try {
          const resPlastic = await getStateCollectionReport(stateYear, program);
          setStateCollectionReport(JSON.parse(resPlastic).data);
        } catch (error) {}
      };
      getReport();
    }
  }, [stateYear, program]);
  useEffect(() => {
    if (locColYear || program) {
      const getReport = async () => {
        try {
          const resPlastic = await getLocationCollectionReport(
            locColYear,
            program
          );
          setLocationCollectionReport(JSON.parse(resPlastic).data);
        } catch (error) {}
      };
      getReport();
    }
  }, [locColYear, program]);
  useEffect(() => {
    if (topLocationYear || program) {
      const getTopLocations = async () => {
        const res = await getTopFiveLocations(topLocationYear, program);
        setTopFiveLocation(JSON.parse(res).data);
      };
      getTopLocations();
    }
  }, [topLocationYear, program]);
  useEffect(() => {
    if (topStateYear || program) {
      const getTopStates = async () => {
        const res = await getTopFiveStates(topStateYear, program);
        setTopFiveStates(JSON.parse(res).data);
      };
      getTopStates();
    }
  }, [topStateYear, program]);
  useEffect(() => {
    if (collectionTargetYear || program) {
      const getCollectionTarget = async () => {
        const res = await getCollectionTargetReport(
          collectionTargetYear,
          program,
          colTargetAggregatorId?.value
        );
        setCollectionTargetReport(JSON.parse(res).data);
      };
      getCollectionTarget();
    }
  }, [colTargetAggregatorId?.value, collectionTargetYear, program]);

  useEffect(() => {
    if (program) {
      const getSourceOfPlastic = async () => {
        try {
          const res = await getAllSourceOfPlastics(program);
          setSourceOfPlastic(JSON.parse(res).data || []);
          setSourceOfPlasticId(null);
        } catch (error) {}
      };
      getSourceOfPlastic();
    }
  }, [program]);
  useEffect(() => {
    if (program) {
      const getTypeOfPlastic = async () => {
        try {
          const res = await getAllTypeOfPlastics(program);
          setTypeOfPlastic(JSON.parse(res).data || []);
          setTypeOfPlasticId(null);
        } catch (error) {}
      };
      getTypeOfPlastic();
    }
  }, [program]);

  const getAllStates = async (program) => {
    setLoading(true);
    const res = await getState(program);
    return res;
  };
  const getAllLgas = async (program) => {
    setLoading(true);
    const res = await getLga(program);
    return res;
  };
  const getAllTypeOfPlastics = async (program) => {
    try {
      setLoading(true);
      const res = await getTypeOfPlastic(program);
      return res;
    } catch (error) {}
  };
  const getAllSourceOfPlastics = async (program) => {
    try {
      setLoading(true);
      const res = await getSourceOfPlastic(program);
      return res;
    } catch (error) {}
  };
  const getTopFiveAggregators = async (year, program) => {
    setLoading(true);
    const res = await getTopAggregators(year, program);
    return res;
  };
  const getTopFiveCollectors = async (year, program) => {
    setLoading(true);
    const res = await getTopCollectors(year, program);
    return res;
  };
  const getTopFiveStates = async (year, program) => {
    setLoading(true);
    const res = await getTopState(year, program);
    return res;
  };
  const getTopFiveLocations = async (year, program) => {
    setLoading(true);
    const res = await getTopLocation(year, program);
    return res;
  };
  const getAllProgram = async () => {
    setLoading(true);
    const res = await getProgram();
    return res;
  };
  const getAllPerformanceReport = async ({
    program,
    sourceOfPlasticId,
    typeOfPlasticId,
    aggregatorId,
    startDate,
    endDate,
  }) => {
    setLoading(true);
    const res = await getPerformanceReport(
      program,
      sourceOfPlasticId,
      typeOfPlasticId,
      aggregatorId,
      startDate,
      endDate
    );
    return res;
  };
  const getAllParticipantReport = async (program) => {
    setLoading(true);
    const res = await getParticipantReport(program);
    return res;
  };
  const getLgaFromState = async (id) => {
    setLoading(true);
    const res = await getLgaByState(id);
    return res;
  };

  return {
    loading,
    getAllStates,
    getLgaFromState,
    getAllLgas,
    getAllTypeOfPlastics,
    getAllSourceOfPlastics,
    getTopAggregators,
    getTopCollectors,
    getTopFiveStates,
    getTopFiveLocations,
    getAllProgram,
    getAllPerformanceReport,
    getAllParticipantReport,
    paReport,
    peReport,
    setPeStartDate,
    setPeEndDate,
    topFiveCollector,
    setTopFiveColYear,
    setTopFiveAggYear,
    topFiveAggregator,
    collectionReport,
    processedReport,
    setProcessedYear,
    setCollectionYear,
    setStateYear,
    stateCollectionReport,
    locationCollectionReport,
    setLocColYear,
    topFiveStates,
    topFiveLocation,
    setTopStateYear,
    setTopLocationYear,
    typeOfPlastic,
    sourceOfPlastic,
    typeOfPlasticId,
    sourceOfPlasticId,
    aggregatorId,
    setCollectionReportTimeline,
    setProcessedReportTimeline,
    collectionReportTimeline,
    processedReportTimeline,
    setTypeOfPlasticId,
    setSourceOfPlasticId,
    setAggregatorId,
    setColTypeOfPlasticId,
    setColSourceOfPlasticId,
    setOfftakeTypeOfPlasticId,
    setOfftakeSourceOfPlasticId,
    colTypeOfPlasticId,
    colSourceOfPlasticId,
    offtakeTypeOfPlasticId,
    offtakeSourceOfPlasticId,
    processedYear,
    collectionYear,
    collectionTargetReport,
    setCollectionTargetYear,
    collectionTargetYear,
    setColTargetAggregatorId,
    colTargetAggregatorId,
  };
};

export default useResource;
